import { attributeReportDeficit } from "@nexus/contracts";
import type { ScoreAttribution } from "@nexus/contracts";

import type { PreflightReportDetail } from "../types/preflight.types";
import { scoredReportAssets } from "./report-blockers";

export type { ScoreAttribution, CriterionAttribution } from "@nexus/contracts";

/**
 * Adapt one report into the score-attribution model. The arithmetic lives in
 * `@nexus/contracts` so the exports and the server-side PDF can share it; this is only the
 * report-shaped entry point, mirroring how `computeTopBlockers` wraps `aggregateBlockers`.
 */
export function computeScoreAttribution(
  report: PreflightReportDetail,
): ScoreAttribution {
  return attributeReportDeficit(
    scoredReportAssets(report).map((asset) => ({
      features: asset.features,
      score: asset.score,
      hasUnanalyzed: asset.hasUnanalyzed,
    })),
    report.overallScore,
  );
}

/** Whether there is a deficit AND criteria to attribute it to — the tab's gate. */
export function hasScoreComposition(attribution: ScoreAttribution): boolean {
  return attribution.observedGap > 0 && attribution.rows.length > 0;
}
